import * as mutationType from "../mutation_types";

const state = {
  customer_overview: {},
  customers: [],
  customer: { primaryContact: {} },
  primary_contacts: [],
  core_coaches: [],
  customer_settings: {},
  partner_customers: []
};

const getters = {
  customer_overview: state => state.customer_overview,
  customers: state => state.customers,
  customer: state => state.customer,
  primary_contacts: state => state.primary_contacts,
  core_coaches: state => state.core_coaches,
  customer_settings: state => state.customer_settings,
  partner_customers: state => state.partner_customers
};

const actions = {
  getCustomers({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/customers")
        .then(res => {
          commit(mutationType.SET_CUSTOMERS_OVERVIEW, res.data);
          commit(mutationType.SET_CUSTOMERS, res.data.customers);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getPartners({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/partners")
        .then(res => {
          commit(mutationType.SET_CUSTOMERS, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getPartnerCustomers({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`/api/partners/${id}/customers`)
        .then(res => {
          commit(mutationType.SET_PARTNER_CUSTOMERS, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getCustomer({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`/api/customers/${id}`)
        .then(res => {
          commit(mutationType.SET_CUSTOMER, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  resetCustomerAndProfile({ commit }) {
    return new Promise(resolve => {
      commit(mutationType.SET_CUSTOMER, { primaryContact: {} });
      resolve();
    });
  },
  // eslint-disable-next-line no-empty-pattern
  addCustomer({}, customer) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post("/api/customers", customer)
        .then(res => {
          resolve(res.data.id);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getPrimaryContacts({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`/api/customers/${id}/contacts`)
        .then(res => {
          commit(mutationType.SET_CUSTOMER_PRIMARY_CONTACTS, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getCoreCoaches({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`/api/customers/${id}/corecoaches`)
        .then(res => {
          commit(mutationType.SET_CUSTOMER_CORE_COACHES, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  updateCustomer({ commit }, customer) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`/api/customers/${customer.id}`, customer)
        .then(res => {
          commit(mutationType.SET_CUSTOMER, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  deleteCustomer({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .delete(`/api/customers/${id}`)
        .then(() => {
          commit(mutationType.DELETE_CUSTOMER, id);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getCustomerSettings({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`/api/customers/${id}/settings`)
        .then(res => {
          commit(mutationType.SET_CUSTOMER_SETTINGS, res.data);
          resolve(res.data);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  }
};

const mutations = {
  [mutationType.SET_CUSTOMERS_OVERVIEW](state, item) {
    state.customer_overview = item;
  },
  [mutationType.SET_CUSTOMERS](state, list) {
    state.customers = list;
  },
  [mutationType.SET_CUSTOMER](state, item) {
    state.customer = item;
    if (item.id) {
      let index = state.customers.findIndex(c => c.id == item.id);
      if (index >= 0) {
        state.customers.push(item);
      }
    }
  },
  [mutationType.DELETE_CUSTOMER](state, id) {
    let index = state.customers.findIndex(c => c.id == id);
    if (index >= 0) {
      state.customers.splice(index, 1);
    }
  },
  [mutationType.SET_PARTNER_CUSTOMERS](state, list) {
    state.partner_customers = list;
  },
  [mutationType.SET_CUSTOMER_PRIMARY_CONTACTS](state, list) {
    state.primary_contacts = list;
  },
  [mutationType.SET_CUSTOMER_CORE_COACHES](state, list) {
    state.core_coaches = list;
  },
  [mutationType.SET_CUSTOMER_SETTINGS](state, item) {
    state.customer_settings = item;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
